<template>
    <div class="product-creator flex justify-center items-center w-full max-w-screen-xl h-full mx-auto px-6 py-12">
        <div class="w-full lg:w-2/3 grid grid-cols-2 gap-8 lg:gap-16">

            <div v-for="accessory in accessories" :key="accessory.key">
                <div class="h-36 w-full mb-8 bg-contain bg-center bg-no-repeat" :style="{ backgroundImage: 'url(' + accessory.primary_image.path + ')' }"></div>
                <div class="mb-12 text-center">{{ accessory.name }}</div>
                <Button class="w-full" @click="select(accessory.id)">
                    {{ __('home::orders.select') }} 
                    <ChevronRightIcon class="h-4 w-4 ml-2" />
                </Button>
            </div>

        </div>    
    </div>
</template>

<script>
    import axios from 'axios'
    import collect from 'collect.js'

    import {
        ChevronRightIcon,
    } from '@heroicons/vue/outline'

    export default {
        components: {
            ChevronRightIcon,
        },
        props: {
            template: String,
            order: Object,
            products: Object,
        },
        data() {
            return {
                accessories: collect(this.products)
                    .where('category', 'accessories')
                    .all(),
            }
        },
        methods: {
            select(accessory) {
                let request = {
                    accessory: accessory,
                };

                axios
                    .patch(this.$route('home::orders.update', { uuid: this.order.uuid }), request)
                    .then((res) => {
                        this.$emit('update:accessory', accessory);
                    });
            },
        },
    }
</script>